import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src413009145/src/ohio-university-system-frontend/app/context/client-provider.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src413009145/src/ohio-university-system-frontend/components/atoms/Loader.css");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src413009145/src/ohio-university-system-frontend/styles/globals.scss");
